module.exports = __webpack_public_path__ + "img/photo_boy.cfeb9770.png";